module.exports = __webpack_public_path__ + "img/reward-header.9dbbbe62.png";